import {Plan} from 'types'
import {ElementSize} from "./elementSize";

export interface FloorSize extends ElementSize {}

export const getFloorSize = (plan: Plan) => {
  const floor = plan.floor
  if (!floor) {
    return {width: 0, length: 0, height: 0, x: 0, y: 0}
  }
  return {
    width: plan.width + 2 * plan.wallWidth,
    length: plan.length + 2 * plan.wallWidth,
    height: floor.thickness,
    x: -plan.wallWidth,
    y: -plan.wallWidth
  }
}

export const getBevelWidth = (): number => 2.5
export const getBevelHeight = (): number => 3
